module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/472.2b8a4a71.png";